module.exports = __webpack_public_path__ + "static/media/bg_new.94a26b03.jpg";